import { render, staticRenderFns } from "./vGrandfatheredSubscriptionWarningModal.vue?vue&type=template&id=ab451ec8"
import script from "./vGrandfatheredSubscriptionWarningModal.vue?vue&type=script&lang=ts"
export * from "./vGrandfatheredSubscriptionWarningModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports